import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Carousel, message } from "antd";
import { GetMoreWorkAxios } from "./ajax";
import { NavLink } from "react-router-dom";
import { useCanvas } from "./../components/canvas";
import { useShadow } from "./../components/shadow";
import { Floatingpc } from "../components/floatingpc";
import { Floatingph } from "../components/floatingph";
import { BottomIfor } from "./bottom/bottominfo";
import { ButtonforPh } from "./bottom/buttomforph";
import { SlideBanner } from "./slideimg";
import { ThreeCourseInfo } from "./threecourse";
import { OurService } from "./ourservice";
import { OurStrengthBox } from "./ourstrengthbox/ourstrengthbox";
import { MainTeach } from "./mainteach";
import { NewsActiveHome } from "./newsparthome";
function HomePage(props) {
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState([]);
  const [show, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
  const reload = async () => {
    setLoading(true);
    let res = await GetMoreWorkAxios();
    if (res.code !== 0) {
      message.error(res.message);
      return;
    } else {
      setLoading(false);
      setChange(res.data);
    }
  };
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
    // e.nativeEvent.preventDefault()
  };
  useEffect(() => {
    reload();
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      document.documentElement.style.overflow = "hidden";
    });
    document.addEventListener("touchstart", hideFloating);
    // document.addEventListener("touchend", prevent);
  }, []);
  return (
    <div>
      <SlideBanner />
      <OurService />
      <ThreeCourseInfo />
      {loading ? "" : <OurStrengthBox />}
      <MainTeach />
      <Row>
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          <div className="MoreWork-pc">
            <div className="minwidthrest">
              <div className="more-work-title">
                <div className="en-more-work-title">MORE WORKS</div>
                <div className="cn-more-work-title">更多作品</div>
              </div>
              <div className="morework-slide-box">
                <MoreWorksPc change={change} setChange={setChange} />
              </div>
            </div>
          </div>
          <div className="assistant-pc">
            <AssistantGroupPc />
          </div>
          <Floatingpc
            show={show}
            showWindow={showWindow}
            text={text}
            setText={setText}
          />
          {/* <div
            className={!show ? "floating" : "hide"}
            onMouseEnter={() => showWindow(true)}
          >
            <div className="top">
              <div className="head-portrait"></div>
            </div>
            <div className="bottom"></div>
          </div>
          <div
            className={show ? "floating-window" : "hide"}
            onMouseLeave={() => showWindow(false)}
          >
            <div className="top">
              <div className="head-portrait"></div>
            </div>
            <div className="bottom">
              <div className="contract"></div>
              <div className="KKname"></div>
              <div className="QQ"></div>
            </div>
            <div className="button">
              <CopyToClipboard
                text="3007920250"
                onCopy={() => setText("已复制")}
              >
                <div className={text === "已复制" ? "hide" : "button1"}>
                  <div className="copy"></div>
                </div>
              </CopyToClipboard>
              <div className={text === "一键复制QQ号" ? "hide" : "button1"}>
                <div className="alcopy"></div>
              </div>
              <div className="button2">
                <Link to="/commonproblem/seid/0">
                  <div></div>
                </Link>
              </div>
            </div>
          </div> */}
        </Col>
        <Col xs={24} sm={24} md={24} lg={0} xl={0}>
          <Floatingph
            showmp={showmp}
            showFloating={showFloating}
            text={text}
            setText={setText}
          />
          {/* <div
            className={!showmp ? "floating-mp" : "hide"}
            onClick={(e) => showFloating(e)}
          >
            <div></div>
          </div>
          <div
            className={showmp ? "floating-mp-window" : "hide"}
            onTouchStart={(e) => showFloating(e)}
          >
            <div className="top">
              <div className="head-portrait"></div>
            </div>
            <div className="bottom">
              <div className="contract"></div>
              <div className="KKname"></div>
              <div className="QQ"></div>
            </div>
            <div className="button">
              <CopyToClipboard
                text="3007920250"
                onCopy={() => setText("已复制")}
              >
                <div className={text === "已复制" ? "hide" : "button1"}>
                  <div className="copy"></div>
                </div>
              </CopyToClipboard>
              <div className={text === "一键复制QQ号" ? "hide" : "button1"}>
                <div className="alcopy"></div>
              </div>
              <div className="button2">
                <Link to="/commonproblem/seid/0">
                  <div></div>
                </Link>
              </div>
            </div>
          </div> */}
          <div className="more-work-ph">
            {/* <img alt="加载中" src="more_work_ph_02.jpg" width="100%" height="100%"/> */}
            <MoreWorkPh change={change} setChange={setChange} />
          </div>
          <div className="assistant-ph">
            <AssistantGroupPh />
          </div>
        </Col>
      </Row>
      <NewsActiveHome {...props} />
      <Row>
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          <BottomIfor />
        </Col>
        <Col xs={24} sm={24} md={24} lg={0} xl={0}>
          <ButtonforPh />
        </Col>
      </Row>
    </div>
  );
}

export function RenderBigImg(props) {
  let { change, index } = props;

  const [page, setPage] = useState(index);
  return (
    <div className="big-image-box">
      <div className="tomiddlecenter">
        <div
          style={{
            height: "30px",
            textAlign: "center",
            fontSize: "22px",
            fontFamily: "SourseHanSansCN-Medium",
          }}
        >
          <span>{change[page] ? change[page].description : ""}</span>
        </div>
        <div className="imgrendermiddlebox">
          <div
            className="left-arrow"
            onClick={() => {
              setPage((state) => (state === 0 ? change.length - 1 : state - 1));
            }}
          ></div>
          <div className="middlecenterbottom">
            {change.map((i, _index) => {
              let cssJson =
                _index === page
                  ? { opacity: 1, transition: "0.9s all" }
                  : { opacity: 0 };
              return (
                <div style={cssJson} className="intolittle" key={i.url}>
                  <img alt="jiazaiz" src={i.url} className="intolittle-img" />
                </div>
              );
            })}
          </div>
          <div
            className="right-arrow"
            onClick={() => {
              setPage((state) => (state >= change.length - 1 ? 0 : state + 1));
            }}
          ></div>
        </div>
      </div>

      <div className="page">
        {page + 1}/{change.length}
      </div>
    </div>
  );
}

let timer = null;
export function MoreWorksPc(props) {
  const [index, setIndex] = useState(undefined);
  const dataCurrent = useRef("");
  let { change, setChange } = props;
  let setCanvas = useCanvas(
    useMemo(
      () => (
        <RenderBigImg change={change} index={index} setChange={setChange} />
      ),
      [index, change, setChange]
    )
  );
  let oDiv = useRef();

  useEffect(() => {
    if (!change.length) return;
    let oBox = document.querySelector(".more-work-box");
    let oUl = oBox.getElementsByTagName("ul")[0];
    let oLi = oUl.getElementsByTagName("li");
    dataCurrent.current =
      dataCurrent.current === ""
        ? oUl.innerHTML + oUl.innerHTML
        : dataCurrent.current;
    oUl.innerHTML = dataCurrent.current;
    let target = oLi[0].offsetWidth * oLi.length;
    let ispeed = -Math.ceil(Math.random() * (target / 2)) + 1;
    function move() {
      ispeed -= 1;
      if (ispeed < -(target / 2)) {
        ispeed = 0;
      }
      oUl.style.transform = `translateX(${ispeed}px)`;
    }
    const clearSpeed = () => {
      timer && clearInterval(timer);
    };
    const openSpeed = () => {
      timer = setInterval(move, 25);
    };
    clearSpeed();
    openSpeed();
    // oBox.addEventListener('mouseover',clearSpeed,false)
    //  oBox.addEventListener('mouseout',openSpeed,)
    oUl.onclick = function (e) {
      if (e.target.parentNode.parentNode.tagName === "LI") {
        setCanvas(true);
        oBox.onmouseout = null;
        setIndex(change.findIndex((j) => e.target.src.match(j.url) !== null));
      }
    };

    return () => {
      //  oBox.removeEventListener('mouseover',clearSpeed)
      //  oBox.removeEventListener('mouseout',openSpeed)
      clearInterval(timer);
      timer = null;
    };
  }, [change, setCanvas]);

  return (
    <div className="more-work-box" ref={oDiv}>
      <ul>
        {change && change.length > 0
          ? change.map((i) => {
              return (
                <li key={i.url}>
                  <div
                    style={{
                      width: "620px",
                      height: "432px",
                      objectFit: "cover",
                      overflow: "hidden",
                    }}
                  >
                    <img className="morework-img" src={i.url} alt="加载中" />
                  </div>
                  <div className="description-style">
                    <span>{i.description}</span>
                  </div>
                </li>
              );
            })
          : null}
      </ul>
    </div>
  );
}
function AssistantGroupPc(props) {
  return (
    <div className="assistant-box-pc">
      <div className="assistant-box-pc-text">
        <div className="cn-pc-assistant-works">
          <span>助教团队作品</span>
        </div>
        <div className="en-pc-assistant-works">
          <span>ASSISTANT </span>
          <span>WORKS</span>
        </div>
      </div>
      <NavLink className="pc-find-more-btn" to="/teach">
        <div>
          <span>查看更多</span>
        </div>
      </NavLink>
    </div>
  );
}

export class RenderBigImgPh extends React.Component {
  state = {
    page: this.props.index + 1,
    page2: this.props.index + 1,
  };

  componentDidMount() {
    this.ImagBox.goTo(this.props.index, true);
  }

  settings = {
    speed: 300,
  };

  render() {
    return (
      <div className="big-img-box-ph">
        <div className="make-flex">
          <div>
            <Carousel
              beforeChange={(_, next) => {
                this.setState({
                  page2: next,
                });
              }}
              slickGoTo={this.state.page}
              ref={(id) => (this.ImagBox = id)}
              dots={false}
              afterChange={(index) => {
                this.setState({
                  page: index + 1,
                });
              }}
              {...this.settings}
            >
              {this.props.change.map((i) => {
                return (
                  <div key={i.url}>
                    <div className="description-ph">
                      <span>{i.description}</span>
                    </div>
                    <div className="intolittle-ph">
                      {" "}
                      <img alt="jiazaiz" src={i.url} />
                    </div>
                  </div>
                );
              })}
            </Carousel>
            <div className="page-style">
              {this.state.page2 + 1}/{this.props.change.length}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function MoreWorkPh(props) {
  let { change } = props;

  const [imgindex2, setImgIndex2] = useState(0);
  const [index, setIndex] = useState(undefined);
  const imgbox = useRef();
  const next = () => {
    imgbox && imgbox.current.next();
  };

  // useEffect(() => {
  //   let timer = setInterval(() => {
  //     imgbox.current.next()
  //   }, 2000)
  //   return () => {
  //     clearInterval(timer)
  //   }
  // }, [])

  const prev = () => {
    imgbox && imgbox.current.prev();
  };

  let setShadow = useShadow(
    useMemo(
      () => <RenderBigImgPh change={change} index={index} />,
      [index, change]
    )
  );
  let settings = {
    autoplay: true,
    arrows: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    dots: false,
  };
  return (
    <div className="more-work-ph-box">
      <div className="more-work-ph-box-entext">
        <span>MORE WORKS</span>
      </div>
      <div className="more-work-ph-cn">更多作品</div>
      <div className="ph-slide-box">
        <div
          className="left-arrow-ph"
          onClick={(e) => {
            prev();
          }}
        ></div>
        <div
          className="right-arrow-ph"
          onClick={(e) => {
            next();
          }}
        ></div>
        <div
          className="make-center"
          onClick={(e) => {
            if (e.target.tagName !== "IMG") {
              return;
            } else {
              setShadow(true);
              setIndex(
                change.findIndex((j) => e.target.src.match(j.url) !== null)
              );
            }
          }}
        >
          <Carousel
            {...settings}
            ref={imgbox}
            beforeChange={(_, next) => {
              setImgIndex2(next);
            }}
            lazyLoad="progressive"
          >
            {change && change.length > 0
              ? change.map((i) => {
                  return (
                    <div key={i.url}>
                      <div className="showimg-ph">
                        <img src={i.url} alt="加载中" />

                        <div className="explain-text">{i.description}</div>
                      </div>
                    </div>
                  );
                })
              : null}
          </Carousel>
          {change && change.length > 0 ? (
            <div className="page-style">
              {imgindex2 + 1}/{change.length}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
function AssistantGroupPh(props) {
  return (
    <div className="assistant-box">
      <div className="assistant-box-text">
        <div className="cn-assistant-works">
          <span>助教团队作品</span>
        </div>
        <div className="en-assistant-works">
          <span>ASSISTANT </span>
          <span>WORKS</span>
        </div>
      </div>
      <NavLink to="/teach">
        <div className="find-more-btn">
          <span>查看更多</span>
        </div>
      </NavLink>
    </div>
  );
}

export default HomePage;
